// extracted by mini-css-extract-plugin
module.exports = {"gutterBottom":"SubsidiaryEntityEditForm_gutterBottom__2fAgR","info":"SubsidiaryEntityEditForm_info__3tQ4X"};